export const asyncImportSVG = async (name) => await import(`./icons/${name}.js`);
//# sourceMappingURL=asyncImportSVG.js.map
// @zapier/design-system@6.3.0 (1dc71580e)
